import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;
    @media screen and (max-width: 768px) {
        .ant-table table td {
            display: ${props => props.display};
            grid-template-columns: 1fr 1fr;       

            justify-content: center;
            align-items: center;
        }
        .ant-table table th {
            display: none;
        }
        .ant-table table td::before {
            font-weight: bold;
            padding-right: 5px;
        }
        .ant-table table tr td {
            padding: 6px 16px !important;
        }
        .ant-table table tr td:first-child {
            padding-top: 16px !important;
        }
        .ant-table table tr td:last-child {
            padding-bottom: 16px !important;
        }
        .ant-table table td:nth-child(1)::before {
            content: "${props => props.dataTitles[0]}";
        }
        .ant-table table td:nth-child(2)::before {
            content: "${props => props.dataTitles[1]}:"; 
        }
        .ant-table table td:nth-child(3)::before {
            content: "${props => props.dataTitles[2]}:";  
        }
        .ant-table table td:nth-child(4)::before {
            content: "${props => props.dataTitles[3]}:";     
        }
        .ant-table table td:nth-child(5)::before {
            content: "${props => props.dataTitles[4]}:";
        }
        .ant-table table td:nth-child(6)::before {
            content: "${props => props.dataTitles[5]}:"; 
        }
        .ant-table table td:nth-child(7)::before {
            content: "${props => props.dataTitles[6]}:";
        }
        .ant-table table td:nth-child(8)::before {
            content: "${props => props.dataTitles[7]}:";    
        }
        .ant-table table td:nth-child(9)::before {
            content: "${props => props.dataTitles[8]}:";
        }
        .ant-table table td:nth-child(10)::before {
            content: "${props => props.dataTitles[9]}: ";
        }
        .ant-table table td:nth-child(11)::before {
            content: "${props => props.dataTitles[10]}: ";
        }
        .ant-table table td:nth-child(12)::before {
            content: "${props => props.dataTitles[11]}: ";
        }
        .ant-table table tr {
            outline: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: 20px;
            display: block;
            -webkit-box-shadow: 4px 9px 10px 0px rgba(214, 214, 214, 1);
            -moz-box-shadow: 4px 9px 10px 0px rgba(214, 214, 214, 1);
            box-shadow: 0px 4px 4px 0px rgba(214, 214, 214, 1);
        }
    }
`;
export const ActionButtons = styled.div`
    flex-direction: row;
`;
